import { ErrorHandler, Injectable } from '@angular/core'
import { AppConfig } from '@env/environment'

@Injectable({
	providedIn: 'root',
})
export class Logger {
	constructor(private errorHandler: ErrorHandler) {}

	log(value: any, ...rest: any[]) {
		if (!AppConfig.production) {
			console.log(value, ...rest)
		}
	}

	error(error: Error) {
		this.errorHandler.handleError(error)
	}

	warn(value: any, ...rest: any[]) {
		console.warn(value, ...rest)
	}
}
